export const utilizadoresInitialState = {
  utilizadores: [],
  perfis: [],
  novoUtilizador: [],
  utilizador: [],
  utilizadorRemovido: [],
  utilizadorEditado: [],
};
